import { render, staticRenderFns } from "./VerticalSlide.vue?vue&type=template&id=3164ef4c"
import script from "./VerticalSlide.vue?vue&type=script&lang=js"
export * from "./VerticalSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports